import LeftMenuCard from "leftMenu/LeftMenuCard";
import { usersMenu } from "staticData";
import { ModulePrefixes } from "enums";
import { useUserLimitReached } from "hooks/plan";
import {
  LimitReachedCard,
  MainButton,
  ModuleLimitDetail,
} from "commonUI";
import { BillingIcon } from "allIcons";
import { useUserPermissions } from "hooks/user";
import { isEqual } from "helpers";
import { t } from "i18next";
import { UnlimitedPlanValue } from "enums/plans";

export default function UserMenu() {
  const { isLoading, isLimitReached, usagePercentage, totalUsers, members } =
    useUserLimitReached();
  const { app_users_view_users } = useUserPermissions();
  return (
    <>
      <div className="card-div">
        {usersMenu(app_users_view_users).map((item, index) => (
          <LeftMenuCard
            key={`${index}-${item.module}`}
            {...item}
            title={t(item.title)}
            prefix={ModulePrefixes.USERS}
            link={`${ModulePrefixes.USERS}/${item.module}`}
            mathcingTab={app_users_view_users ? "roles" : "team-members"}
          />
        ))}
      </div>
        {isLoading ? (
          ""
        ) : (
          <div className="users-limit-card">
            <LimitReachedCard
              show={isLimitReached}
              title={t("users.limitReached.title")}
              description={t("users.limitReached.description")}
            />
            <ModuleLimitDetail
              title={t("sites.usersUsageDetail.title")}
              description={
                isEqual(totalUsers, UnlimitedPlanValue)
              ? t("sites.usersUsageDetail.unlimitedUsers", {
                currentUsers: members,
              })
              : t("sites.usersUsageDetail.body", {
                currentUsers: members,
                totalUsers: totalUsers,
                usagePercentage: Number(usagePercentage).toFixed(2),
              })
              }
              progress={usagePercentage}
            />
            <a
              href="https://wpsitelauncher.com/customer-dashboard/?action=index&model=subscription"
              target="_blank"
              rel="noreferrer"
            >
              <MainButton>
                <BillingIcon fill="white" />
                {t("common.button.managePlan")}
              </MainButton>
            </a>
          </div>
        )}
    </>
  );
}
